var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHelp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#949494",
  fillRule: "evenodd",
  d: "M8 1.767A6.24 6.24 0 0 0 1.767 8 6.24 6.24 0 0 0 8 14.233 6.24 6.24 0 0 0 14.233 8 6.24 6.24 0 0 0 8 1.767M.667 8A7.34 7.34 0 0 1 8 .667 7.34 7.34 0 0 1 15.333 8 7.34 7.34 0 0 1 8 15.333 7.34 7.34 0 0 1 .667 8",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#949494",
  fillRule: "evenodd",
  d: "M8 4.983c-.8 0-1.45.65-1.45 1.45a.55.55 0 1 1-1.1 0 2.55 2.55 0 1 1 5.1 0c0 .972-.646 1.587-1.107 2.027l-.063.06c-.52.497-.83.835-.83 1.362a.55.55 0 0 1-1.1 0c0-1.039.668-1.677 1.146-2.135l.024-.022c.536-.514.83-.821.83-1.292 0-.8-.65-1.45-1.45-1.45",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#949494",
  d: "M8.542 11.65a.542.542 0 1 1-1.084 0 .542.542 0 0 1 1.084 0"
})));
export { SvgHelp as ReactComponent };